import { PaletteMode } from '@material-ui/core';

export const getThemeFromStorage = () =>
  localStorage.getItem('themeMode')
    ? (localStorage.getItem('themeMode') as PaletteMode)
    : 'light';
